var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[_c('div',{staticClass:"sidebar"},[_c('list')],1),_c('div',{staticClass:"main"},[_c('chattitle'),_c('message'),_c('usertext')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }